module.exports = __webpack_public_path__ + "img/4.7fa16d3a.png";